/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ErroreClientOccorrenzaDTO } from './errore-client-occorrenza-dto';


export interface PagedModelErroreClientOccorrenzaDTO { 
    content?: Array<ErroreClientOccorrenzaDTO>;
    page?: PageMetadata;
}

